import type { IParams } from './base';
import Rights1 from './rights-1';
import Rights3 from './rights-3';
import Rights10 from './rights-10';
import Rights15 from './rights-15';
import Rights16 from './rights-16';
import Rights24 from './rights-24';
import { SHOW_ORG_KEY, USER_LEVEL_KEY } from '~/api/interface';

export function getRightsView(options: IParams) {
  const {
    rights: { rights_type },
  } = options;

  if (rights_type === USER_LEVEL_KEY.PERSONAL_LITE) {
    return new Rights3(options);
  }
  if (rights_type === USER_LEVEL_KEY.PERSONAL) {
    return new Rights10(options);
  }
  if (rights_type === USER_LEVEL_KEY.TEAM_TASTE) {
    return new Rights15(options);
  }
  if (rights_type === USER_LEVEL_KEY.TEAM_LIGHT) {
    return new Rights16(options);
  }
  if (rights_type === SHOW_ORG_KEY.ORG_SHOW) {
    return new Rights24(options);
  }

  return new Rights1(options);
}
